import { useMemo } from 'react';
import { getCategoryCode, getCategoryLabel, getFileType } from '@components/documents/documentFilters';

export interface DocumentFacets {
  categories: string[];
  categoryLabels?: Record<string, string>;
  tags: string[];
  fileTypes: string[];
  uploadedBy: string[];
}

const EMPTY: DocumentFacets = { categories: [], tags: [], fileTypes: [], uploadedBy: [] };

const collect = (documents: any[], read: (doc: any) => string | string[] | undefined): string[] => {
  const seen = new Set<string>();
  documents.forEach((doc) => {
    const value = read(doc);
    (Array.isArray(value) ? value : [value]).forEach((entry) => {
      if (entry) seen.add(entry);
    });
  });
  return Array.from(seen).sort((a, b) => a.localeCompare(b));
};

/**
 * Derived through the same accessors filterDocuments compares against, so every
 * offered option matches at least one loaded document. The previous static
 * lists were demo values that matched nothing.
 */
export function useDocumentFacets(documents: any[]): DocumentFacets {
  return useMemo(() => {
    if (documents.length === 0) return EMPTY;

    return {
      categories: collect(documents, getCategoryCode),
      categoryLabels: Object.fromEntries(
        documents.map((doc) => [getCategoryCode(doc), getCategoryLabel(doc)]),
      ),
      tags: collect(documents, (doc) => doc.tags),
      fileTypes: collect(documents, getFileType),
      uploadedBy: collect(documents, (doc) => doc.uploadedBy),
    };
  }, [documents]);
}
